
<template>
  <div class="tz-form">
    <el-form :model="tzForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="订单号" prop="order_id">
    <el-input type="text" v-model="tzForm.order_id" autocomplete="off"></el-input>
  </el-form-item>
  <el-form-item label="姓名" prop="name">
    <el-input type="text" v-model="tzForm.name" autocomplete="off"></el-input>
  </el-form-item>
  <el-form-item label="身份证号码" prop="cardId">
    <el-input type="text" v-model="tzForm.cardId" autocomplete="off"></el-input>
  </el-form-item>

  <el-form-item label="手机号码" prop="phone">
    <el-input type="text" v-model="tzForm.phone" autocomplete="off"></el-input>
  </el-form-item>
  <el-form-item label="装机地址" prop="address">
    <el-input v-model="tzForm.address"></el-input>
  </el-form-item>

   <el-form-item label="宽带类型" prop="type">
   <el-select v-model="tzForm.type" placeholder="请选择"  @change="getTypeId">
     <el-option   v-for="(item,key)  in typeData"   :key="key"  :label="item['name']" :value="item['id']"></el-option>
  </el-select>
  </el-form-item>

   <el-form-item label="宽带套餐" prop="mbps">
   <el-select v-model="tzForm.mbps" placeholder="请选择">
     <el-option   v-for="(item,key)  in mbpsData"   :key="key"  :label="item['name']" :value="item['id']"></el-option>
  </el-select>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>
</el-form>

  </div>
</template>


<script>
import {submitTzOrder,getKdCode,getMealData,getTzProduct,getcard_info} from '@/api/order'
export default {
   props:{
    formdata: {
    type: Object,
    required: true,
  },
   },
     data() {
      return {
        typeData:[],
        mbpsData:[],
        tzForm: {
          name:this.formdata.u_name,
          cardId:'',
          phone:this.formdata.phone,
          address:this.formdata.place,
          type:this.formdata.type,
          mbps:this.formdata.mbps,
          order_id:this.formdata.order_no
        },
        rules: {
          name: [
            { required: true,message: '请输入客户姓名', trigger: 'blur' }
          ],
          cardId: [
            {  required: true,message: '请输入正确的证件号码', trigger: 'blur' }
          ],
          address: [
            { required: true,message: '填写完整的地址', trigger: 'blur' }
          ],
           type: [
            { required: true,message: '选择宽带类型', trigger: 'blur' }
          ],
           mbps: [
            { required: true,message: '选择宽带套餐', trigger: 'blur' }
          ],
           order_id: [
            { required: true,message: '订单号不正确', trigger: 'blur' }
          ],
          phone: [
            { required: true,message: '手机号码不正确', trigger: 'blur' }
          ]
        }
      };
    },
    created(){
     this.getUserInfo()//获取用户的身份信息
     this.getTzList();
     this.getTypeId(this.formdata.type) //根据p_id获取宽带套餐


     
    },
    watch:{
        formdata:{
           handler(newV) {
            this.tzForm.address = newV.place;
            this.tzForm.order_id = newV.order_no;
            this.tzForm.type = newV.type;
            this.getUserInfo();
            this.getTypeId(newV.type);
        },
        // 是否开启深度监
        deep: true
        }
    },
    methods: {
      getTzList(){
         let params={
            id:22 //土洲ID是22
          }
     getTzProduct(params).then(res=>{
        this.typeData=res.data;
     })
      },
      getUserInfo(){
          let params={
            order_id:this.tzForm.order_id
          }
          getcard_info(params).then(res=>{
            this.tzForm.name=res.data.card_name;
            this.tzForm.cardId=res.data.card_no;
       })
      },

      getTypeId(id){
         getMealData(id).then(res=>{
            this.tzForm.mbps='';
            this.mbpsData=res.data;
      })
      },
      getmbpsId(id){

      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.tzForm);
            alert('submit!');
           submitTzOrder().then(res=>{
              this.$emit('listenOrder',res.data);//把返回的订单号返回给父级
           });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  



}
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/tzorder.vue